<template>
  <div class="resolver-wrapper">
    <span v-if="error" class="resolver-error">{{ error }}</span>
    <span v-else class="resolver-loading">
      <span class="spinner-border spinner-border-sm me-2"></span>
      Cargando...
    </span>
  </div>
</template>

<script>
import api from "@/services/apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api/v2/";

export default {
  name: "ResolverEnlace",
  data() {
    return { error: "" };
  },
  async created() {
    const { tipsterSlug, productoSlug } = this.$route.params;
    try {
      const { data } = await api.get(
        `${API_URL}public/p/${encodeURIComponent(tipsterSlug)}/${encodeURIComponent(productoSlug)}`
      );
      if (data?.res === "OK" && data.uuid) {
        this.$router.replace(`/pronostico/${data.uuid}`);
      } else {
        this.error = "Enlace no encontrado.";
      }
    } catch {
      this.error = "Enlace no encontrado.";
    }
  },
};
</script>

<style scoped>
.resolver-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  font-size: 1.1rem;
  color: var(--q-muted);
}
.resolver-error {
  color: var(--q-red, #ef4444);
}
</style>
